import { Badge, Divider, IconButton, ListItemIcon, Menu, MenuItem } from '@mui/material';
import React from 'react';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import CelebrationIcon from '@mui/icons-material/Celebration';
import CloudDoneIcon from '@mui/icons-material/CloudDone';
import GavelIcon from '@mui/icons-material/Gavel';
import { useTranslation } from 'react-i18next';

const Notifications: React.FC = () => {
    const { t } = useTranslation();
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const handleClose = () => {
        setAnchorEl(null);
    };
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleNotificationClick = (/*notification: any*/) => {
        handleClose();
    }

    const fixedData = [
        {
            id: "1f7958d2-0bbf-49d5-b2f9-70be6d15eedd",
            text: "Your portfolio ABC Blend has been saved",
            icon: <CloudDoneIcon />
        },
        {
            id: "e87cc017-5be1-4467-b493-6bca3433d437",
            text: "Lawyers need document for your portfolio ABC Equities",
            icon: <GavelIcon />
        },
        {
            id: "5a5db950-4f51-46c0-88c3-367461676f04",
            text: "Portfolio ReVo Europe has been validated",
            icon: <CelebrationIcon />
        }
    ]

    return <>
        <IconButton
            onClick={handleClick}
            aria-label={t('A11yNotifications')}>
            <Badge color="secondary" variant="dot">
                <NotificationsNoneIcon />
            </Badge>
        </IconButton>
        <Menu
            MenuListProps={{
                'aria-labelledby': 'demo-customized-button',
            }}
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            PaperProps={{
                elevation: 0,
                sx: {
                    overflow: 'visible',
                    filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                    mt: 1.5,
                    '& .MuiAvatar-root': {
                        width: 32,
                        height: 32,
                        ml: -0.5,
                        mr: 1,
                    },
                    '&::before': {
                        content: '""',
                        display: 'block',
                        position: 'absolute',
                        top: 0,
                        right: 14,
                        width: 10,
                        height: 10,
                        bgcolor: 'background.paper',
                        transform: 'translateY(-50%) rotate(45deg)',
                        zIndex: 0,
                    },
                },
            }}
            transformOrigin={{ horizontal: 'right', vertical: 'top' }}
            anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        >
            {fixedData.map((not, index, array) => (
                [
                    
                    // {(index + 1 < array.length) && },
                    <MenuItem sx={{ minWidth: "200px" }} key={not.id} onClick={() => handleNotificationClick(/*not*/)}>
                        {not.icon &&
                            <ListItemIcon>
                                {not.icon}
                            </ListItemIcon>
                        }
                        {not.text}
                    </MenuItem>,
                    <Divider  key={`divider-${not.id}`} sx={{ display: (index + 1 === array.length ? "none": undefined)}} /> 
                ]
            ))}
        </Menu>
    </>;
}

export default Notifications;